import script from "./ReorderDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ReorderDialog.vue?vue&type=script&setup=true&lang=js"

import "./ReorderDialog.vue?vue&type=style&index=0&id=167c2bdd&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-167c2bdd"]])

export default __exports__